import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, Container, Modal } from "@mui/material";
import { useLocationContext } from "../../Hooks/CustomHooks";
import { useLocation, useNavigate } from "react-router-dom";
import { loginRequest } from "../../authConfig";
import { useMsal } from "@azure/msal-react";
import { CustomTextField, CustomDropDown } from "../Inputs/CustomInputs";
import { updatePipeline, getPipeline } from "../../serviceCalls";

import {
  source_destination_types,
  scopes,
  fileTypes,
  columnDelimiters,
} from "./selectOptions";
import { ProgressBar } from "../CustomProgressBar/ProgressBar";
import { successStyle, CheckmarkImg, ErrorDiv } from "./updatePipelineStyles";
import { StyledSelectField } from "../Inputs/CustomInputStyles";
import { getAllSourceDestinationTypes } from "../../serviceCalls";
import { Terminal } from "@mui/icons-material";
const UpdatePipeline = () => {
  const currentLocation = useLocationContext();
  const location = useLocation();
  const { accounts, instance } = useMsal();
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [displayLoading, setDisplayLoading] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [correlationId, setCorrelationId] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [pipelineData, setPipelineData] = useState(
    location.state ? location.state.pipelineData : {}
  );
  const [linkedService, setLinkedService] = useState(
    location.state ? location.state.linkedService : {}
  );
  const pageNo = location.state ? location.state.pageNo : 1;
  const limit = location.state ? location.state.limit : 5;
  const [pipelineName, setPipelineName] = useState(pipelineData.Name);

  const [sourceType, setSourceType] = useState(pipelineData.OriginTypeName);
  const [sourceTypeID, setSourceTypeID] = useState(pipelineData.OriginTypeId);
  const [destinationType, setDestinationType] = useState(
    pipelineData.DestinationTypeName
  );
  const [destinationTypeID, setDestinationTypeID] = useState(
    pipelineData.DestinationTypeId
  );

  const [sourceLinkedService, setSourceLinkedService] = useState(
    pipelineData.OriginLinkedServiceName
  );
  const [destinationLinkedService, setDestinationLinkedService] = useState(
    pipelineData.DestinationLinkedServiceName
  );
  const [scope, setScope] = useState(pipelineData.Scope);
  const [fileType, setFileType] = useState(pipelineData.FileType);
  const [columnDelimiter, setColumnDelimiter] = useState(
    pipelineData.ColumnDelimiter
  );
  const [sourceDestinationTypeData, setSourceDestinationTypeData] = useState(
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const accessToken = await tokenResponse.accessToken;

      const sourceDestinationTypes = await getAllSourceDestinationTypes(
        accessToken
      );
      setSourceDestinationTypeData(sourceDestinationTypes.data);
      console.log(pipelineData);
    };

    fetchData();
  }, []);
  const handleUpdate = async (event) => {
    try {
      setDisplayLoading(true);
      event.preventDefault();
      const updatePipelineData = {
        MappingId: pipelineData.MappingId,
        ReferenceKey: pipelineData.ReferenceKey,
        Name: pipelineName,
        OriginTypeId: sourceTypeID,
        OriginTypeName: sourceType,
        DestinationTypeId: destinationTypeID,
        DestinationTypeName: destinationType,
        OriginLinkedServiceName: sourceLinkedService,
        DestinationLinkedServiceName: destinationLinkedService,
        Scope: scope,
        FileType: fileType,
        ColumnDelimiter: columnDelimiter,
      };
      console.log(updatePipelineData);

      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const accessToken = await tokenResponse.accessToken;
      const response = await updatePipeline(updatePipelineData, accessToken);
      const apiResponse = response?.data;

      if (apiResponse.StatusCode === 200) {
        setDisplayLoading(false);
        setUpdateSuccess(true);
        await setOpen(true);
        await setTimeout(() => {
          setOpen(false);
          navigate("/getallpipelines", {
            state: { pageNo: pageNo, limit: limit },
          });
        }, 2000);
      } else {
        setDisplayLoading(false);
        setCorrelationId(response?.headers["x-correlation-id"]);
        setAlertMsg(apiResponse.Message);
        setAlertSeverity("error");
      }
    } catch (error) {
      setDisplayLoading(false);
      setAlertMsg(error.message);
      setCorrelationId(error.response.headers["x-correlation-id"]);
      setAlertSeverity("error");
    }
  };

  const handleCloseButtonClick = () => {
    navigate("/getallpipelines", { state: { pageNo: pageNo, limit: limit } });
  };

  return (
    <>
      {displayLoading ? (
        <ProgressBar />
      ) : (
        <>
          <Box sx={{ display: "flex", marginLeft: 3, marginBottom: 5 }}>
            <Typography fontSize={48} color="primary">
              Edit - Pipeline
              <img
                style={{
                  margin: "4px 0px 0px 22px",
                }}
                height={45}
                width={50}
                src={require("../../images/PipelineIcon.png")}
                alt="images"
              ></img>
            </Typography>
          </Box>

          <Container
            sx={{
              paddingY: 22,
              boxShadow: 2,
              padding: 2,
              height: 470,
              width: 1215,
            }}
          >
            <Box>
              {alertMsg && (
                <ErrorDiv severity={alertSeverity}>
                  <span>
                    Error Occured: {alertMsg}. Correlation Id : {correlationId}
                  </span>
                </ErrorDiv>
              )}
            </Box>
            <Typography sx={{ margin: -2 }} fontSize={24}>
              Pipeline ID : {pipelineData.MappingId}
            </Typography>

            <CustomTextField
              id="Name"
              placeholder={"Pipeline Name"}
              fieldName={"Pipeline Name"}
              value={pipelineName}
              disabled={true}
              isRequired={true}
              toolTipTitle={
                "Valid Name for the pipeline based on its usage.Pipeline Name should be Unique and should not contain white spaces or special characters."
              }
            />
            <CustomDropDown
              toolTipTitle={
                "Source Type depicts the type of source location that file has to be picked from.Source type can Cloud storage or On prem File server location"
              }
              id={"OriginTypeName"}
              fieldName={"Source Type"}
              value={sourceType}
              isRequired={true}
              menuItems={sourceDestinationTypeData
                .filter((item) => item.IsActive)
                .reduce((obj, item) => {
                  obj[item.Type] = item.Type;
                  return obj;
                }, {})}
              onChange={(e) => {
                setSourceType(e.target.value);
                // console.log(e.target.value);
                // console.log(sourceDestinationTypeData.find(item=>item.Type===e.target.value).TypeId);
                setSourceTypeID(
                  sourceDestinationTypeData.find(
                    (item) => item.Type === e.target.value
                  ).TypeId
                );
              }}
            />
            <CustomDropDown
              toolTipTitle={
                "Destination Type depicts the type of source location that file has to be picked from.Destination type can Cloud storage or On prem File server location"
              }
              id={"DestinationTypeName"}
              fieldName={"Destination Type"}
              value={destinationType}
              isRequired={true}
              menuItems={sourceDestinationTypeData
                .filter((item) => item.IsActive)
                .reduce((obj, item) => {
                  obj[item.Type] = item.Type;
                  return obj;
                }, {})}
              onChange={(e) => {
                setDestinationType(e.target.value);
                console.log(
                  sourceDestinationTypeData.find(
                    (item) => item.Type === e.target.value
                  ).TypeId
                );
                setDestinationTypeID(
                  sourceDestinationTypeData.find(
                    (item) => item.Type === e.target.value
                  ).TypeId
                );
              }}
            />

            <CustomDropDown
              toolTipTitle={
                "Origin Linked service depicts the linked service of source location that file has to be picked from.Source type can Cloud storage or On prem File server location"
              }
              id={"OriginLinkedServiceName"}
              fieldName={"Source Linked Service"}
              value={sourceLinkedService}
              isRequired={true}
              onChange={(e) => {
                setSourceLinkedService(e.target.value);
              }}
              menuItems={linkedService
                .filter((item) => item.linkeServicetype !== "AzureKeyVault")
                .reduce((obj, item) => {
                  obj[item.linkedServiceName] = item.linkedServiceName;
                  return obj;
                }, {})}
            />
            <CustomDropDown
              toolTipTitle={
                "Destination Linked service depicts the linked service of source location that file has to be picked from.Source type can Cloud storage or On prem File server location"
              }
              id={"DestinationLinkedServiceName"}
              fieldName={"Destination Linked Service"}
              value={destinationLinkedService}
              isRequired={true}
              onChange={(e) => setDestinationLinkedService(e.target.value)}
              menuItems={linkedService
                .filter((item) => item.linkeServicetype !== "AzureKeyVault")
                .reduce((obj, item) => {
                  obj[item.linkedServiceName] = item.linkedServiceName;
                  return obj;
                }, {})}
            />
            <CustomDropDown
              toolTipTitle={
                "Scope depicts the container/source to which Event Trigger should be configured"
              }
              id={"Scope"}
              fieldName={"Scope"}
              value={scope}
              isRequired={true}
              onChange={(e) => setScope(e.target.value)}
              menuItems={scopes}
            />
            <CustomDropDown
              id={"FileType"}
              fieldName={"File Type"}
              value={fileType}
              isRequired={true}
              onChange={(e) => setFileType(e.target.value)}
              menuItems={fileTypes}
            />
            <CustomDropDown
              id={"ColumnDelimiter"}
              fieldName={"Column Delimiter"}
              value={columnDelimiter}
              isRequired={true}
              onChange={(e) => setColumnDelimiter(e.target.value)}
              menuItems={columnDelimiters}
            />
          </Container>
          <Container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => handleCloseButtonClick()}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={handleUpdate}
             
            >
              Update
            </Button>
          </Container>

          <div>
            <Modal
              open={open}
              onClose={updateSuccess}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={successStyle}>
                <Box sx={{ display: "flex-inline" }}>
                  <Typography align="center" mb={2} mt={4} fontSize={24}>
                    Pipeline Updated
                  </Typography>
                  <center>
                    <CheckmarkImg
                      onClick={handleClose}
                      src={require("../../images/Checkmark.png")}
                    />
                  </center>
                </Box>
              </Box>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default UpdatePipeline;
